<template>
    <v-dialog-old ref="dialog" id="requestDialog">
        <form>
            <ValidationObserver ref="validation">
                <fieldset>
                    <legend>Заявка на подключение</legend>

                    <label>Имя *</label>
                    <vee-input v-model="M.name"
                               rules="required"
                               input-class="large"
                               name="Имя"
                               autofocus/>

                    <label>Телефон *</label>
                    <ValidationProvider v-slot="{ errors }" rules="phone|required">
                        <input v-mask="'+7 (###) ###-##-##'"
                               v-model="M.phone"
                               class="large"
                               name="Телефон"
                               :class="{'hasError' : errors[0]}"
                               v-tooltip="{content: errors[0], template: $errTemplate}">
                    </ValidationProvider>

                    <label>Email *</label>
                    <vee-input v-model="M.email"
                               rules="required|email"
                               input-class="large"
                               name="Email"/>

                    <label>Комментарий</label>
                    <textarea v-model="M.comment"/>

                    <footer>
                        <v-loading-component @click="submit">
                            <template slot-scope="{ loadingClass }">
                                <button :class="['green', loadingClass]">Отправить</button>
                            </template>
                        </v-loading-component>
                    </footer>
                </fieldset>
            </ValidationObserver>
        </form>
    </v-dialog-old>
</template>

<script>
export default {
    props: {
        urlType: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            M: {
                name:    '',
                phone:   '',
                email:   '',
                comment: '',
                source:  'PROMO',
            },
        }
    },
    methods: {
        show() {
            this.M = {
                name:    '',
                phone:   '',
                email:   '',
                comment: '',
                source:  'PROMO',
            }

            this.$refs.dialog.show();
        },
        submit: function (btn) {
            btn.startLoadingAnimation();

            this.$refs.validation.validate().then(success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    if (el) {
                        el.scrollIntoView({behavior: "smooth"});
                    }

                    btn.stopLoadingAnimation();
                    return;
                }

                this.axios.post('/' + this.urlType + '/promo/submit', this.M).then(response => {
                    btn.stopLoadingAnimation();
                    this.$modal(
                        '<p style="font-size: 20px; text-align: center"><b>Заявка отправлена!</b></p>' +
                        '<p>Мы свяжемся с вами в ближайшее время.</p>', {
                            name: 'OK',
                            callback: () => {
                                this.$refs.dialog.hide();
                            }
                        }, {}, false
                    );
                });
            });
        },
    },
}
</script>

<style>
dialog#requestDialog {
    width: 600px;
}
</style>
